export default {"src":"/_next/static/media/tkn.e4d26b54.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};